export default "__VITE_ASSET__B$_5scWJ__"